<template>
  <div class="form-group">
    <label class="form-label">
      {{ label }}
    </label>

    <div class="input-group">
      <div class="input-group-prepend" v-if="prefix">
        <span class="input-group-text">
          {{ prefix }}
        </span>
      </div>
      <input type="text" :class="classes" v-model="inputVal" :disabled="disabled" :readonly="readonly" :placeholder="placeholder">
      <div class="input-group-append" v-if="postfix">
        <span class="input-group-text">
          {{ postfix }}
        </span>
      </div>
    </div>

    <validation-error :error="error"></validation-error>

    <div class="control-help mt-1" v-if="hasSlot">
      <small class="text-muted">
        <slot />
      </small>
    </div>
  </div>
</template>

<script>

  import ValidationError from "./ValidationError"

  export default {
    name: "InputControl",
    components: {ValidationError},
    props: {
      label: {
        required: true,
        format: String
      },
      error: [Boolean, String],
      value: [String, Number],
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      prefix: String,
      postfix: String,
      placeholder: String,
    },
    computed: {
      classes() {
        let classes = []

        if(this.readonly === false){
          classes.push('form-control')
        }else{
          classes.push('form-control-plaintext')
        }

        if(this.error){
          classes.push('is-invalid')
        }

        return classes.join(' ')
      },
      hasSlot(){
        return this.$slots.default !== undefined
      }
    },
    watch: {
      value(value) {
        this.inputVal = value
      },
      inputVal(value) {
        this.$emit('input', value)
      }
    },
    mounted() {
      this.inputVal = this.value
    },
    data() {
      return {
        inputVal: null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Controls/Input.vue